import { api, apiFile } from '@/utils/api'
import router from '../router'
import alert from '@/helpers/alert'

const state = () => {
  return {
    filterOption: [],
    docStatusOption: [],
    objectiveStatus: [],
    approveStatus: [],
    files: [],
    btnSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnCancel: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDraft: {
      disabled: false,
      loading: false,
      hide: true
    },
    tableTab: {
      label: 'แบบร่าง',
      value: 'draft',
      url: `${process.env.VUE_APP_API_URL}/memo/memo/getMyDocs?status_code=draft`,
      currentUrl: null,
      page: 1
    },
    countMyDoc: 0,
    countEdit: 0,
    search: {
      field: null,
      type: 'like',
      value: null,
      companySelected: []
    }
  }
}

const getters = {
  getFileAttach(state) {
    return state.files.map(item => {
      return {
        id: item.id,
        path_file: item.path_file,
        path_thumbnail: item.path_thumbnail,
        url_file: item.url_file,
        url_thumbnail: item.url_thumbnail
      }
    })
  },
  getApproveName(state) {
    return approve => {
      const tmp = state.approveStatus.find(item => item.value === approve)
      if (tmp) {
        return tmp.label
      } else {
        return ''
      }
    }
  }
}

const mutations = {
  initState(state) {
    state.filterOption = []
    state.docStatusOption = []
    state.objectiveStatus = []
    state.approveStatus = []
    state.files = []
    state.formSubmit = false
    state.formSubmitCancel = false
    state.formSubmitDraft = false
    state.hideSubmitDraft = false
    state.hideSubmit = false

    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.tableTab = {
      label: 'แบบร่าง',
      value: 'draft',
      url: `${process.env.VUE_APP_API_URL}/memo/memo/getMyDocs?status_code=draft`
    }
    state.btnDraft.disabled = true | false
    state.countMyDoc = 0
    state.countEdit = 0
  },
  initBtn(state) {
    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.files = []
  },
  setObjectiveStatus(state, data) {
    state.objectiveStatus = data
  },
  setApproveStatus(state, data) {
    state.approveStatus = data
  },
  setFile(state, data) {
    state.files.push(data)
  },
  removeFile(state, id) {
    const newFile = state.files.filter(item => {
      return item.id !== id
    })
    state.files = newFile
  },
  clearFile(state) {
    state.files = []
  },
  setFilterOption(state, data) {
    state.filterOption = data
  },
  setDocStatusOption(state, data) {
    state.docStatusOption = data
  },
  setBtnActive(state, data) {
    state[data.type].loading = !state[data.type].loading
    state[data.type].disabled = !state[data.type].disabled
  },
  setBtn(state, data) {
    state[data.type][data.value] = !state[data.type][data.value]
  },
  setTableTab(state, tab) {
    state.tableTab.label = tab.label
    state.tableTab.value = tab.value
    state.tableTab.url = tab.url
  },
  setCountMyDoc(state, count) {
    state.countMyDoc = count
  },
  setCountEdit(state, count) {
    state.countEdit = count
  },
  setFilter(state, data) {
    state.search.companySelected = data.companySelected
    state.search.field = data.field
    state.search.value = data.value
  },
  clearFilter(state, data) {
    state.search.companySelected = []
    state.search.field = data.field
    state.search.value = null

    state.tableTab.currentUrl = state.tableTab.url
    state.tableTab.page = 1
  },
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  }
}

const actions = {
  async loadOptionObject({ commit, state }) {
    if (state.objectiveStatus.length == 0) {
      await api.get('/memo/memo/getOptionObjectiveStatus').then(res => {
        commit('setObjectiveStatus', res.data)
      })
    }
  },
  async loadOptionApprove({ commit, state }) {
    if (state.approveStatus.length == 0) {
      await api.get('/memo/memo/getOptionApproveStatus').then(res => {
        commit('setApproveStatus', res.data)
      })
    }
  },
  async loadFilterOption({ commit, state }) {
    if (state.filterOption.length == 0) {
      await api.get('/memo/memo/allOption').then(res => {
        commit('setFilterOption', res.data)
      })
    }
  },
  async loadDocStatusOption({ commit, state, rootState }) {
    if (state.docStatusOption.length == 0) {
      await api
        .get(
          `/memo/memo/getOptionDocMenu?showTabMonitor=${rootState.auth.info.showTabMonitor}&roleCode=${rootState.auth.info.roleCode}`
        )
        .then(res => {
          commit('setDocStatusOption', res.data)
        })
    }
  },
  async createMemo({ commit }, payload) {
    await api.post('/memo/memo/insert', payload).then(async res => {
      if (payload.is_draft) {
        await commit('setBtnActive', { type: 'btnDraft' })
      } else {
        await commit('setBtnActive', { type: 'btnSave' })
      }
      alert.success()
      // await commit(
      //   'notification/toast',
      //   {
      //     type: 'success',
      //     message: 'สำเร็จ',
      //     description: 'บันทึกข้อมูล'
      //   },
      //   { root: true }
      // )
      // await commit('notification/toastShow', {}, { root: true })
      router.back()
    })
  },
  async updateMemo({ commit }, payload) {
    await api
      .put(`/memo/memo/update/${payload.id}`, payload)
      .then(async res => {
        if (!payload.is_draft) {
          await commit('setBtn', { type: 'btnDraft', value: 'hide' })
          await commit('setBtn', { type: 'btnSave', value: 'hide' })
        }
        if (payload.is_draft) {
          await commit('setBtnActive', { type: 'btnDraft' })
        } else {
          await commit('setBtnActive', { type: 'btnSave' })
        }

        alert.success()
        // await commit(
        //   'notification/toast',
        //   {
        //     type: 'success',
        //     message: 'สำเร็จ',
        //     description: 'บันทึกข้อมูล'
        //   },
        //   { root: true }
        // )
        // await commit('notification/toastShow', {}, { root: true })
        // router.back()
      })
  },
  async uploadFile({ commit }, payload) {
    await apiFile.post('/file/upload', payload).then(res => {
      if (res.data.code == 200) {
        for (const i in res.data.data) {
          commit('setFile', res.data.data[i])
        }
      }
    })
  },
  async cancelMemo({ commit }, memoID) {
    await api.put(`/memo/memo/cancel/${memoID}`).then(async res => {
      commit('setBtnActive', { type: 'btnCancel' })
      alert.success()
      // await commit(
      //   'notification/toast',
      //   {
      //     type: 'success',
      //     message: 'ยกเลิกเอกสาร',
      //     description: 'บันทึกข้อมูล'
      //   },
      //   { root: true }
      // )
      // await commit('notification/toastShow', {}, { root: true })
      router.push({ name: 'memoDocAll' })
    })
  },
  async loadCountMyDoc({ commit }, employeeId) {
    await api.get(`/memo/memo/countMyDoc/${employeeId}`).then(async res => {
      if (res.code == 200) {
        commit('setCountMyDoc', res.data.my_doc_wait)
        commit('setCountEdit', res.data.edit_all)
        commit(
          'global/setDocWaitType',
          { type: 'memo', value: res.data.my_doc_wait },
          { root: true }
        )
      }
    })
  },

  setTableTab({ commit }, tab) {
    commit('setTableTab', tab)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
